import React, { useCallback, useState } from 'react';
import { Button } from 'framework/ui/mui-builder';
import { useFieldHelper } from 'framework/ui/field';
import CloseProcessIssueModalForm from 'domain/gpo/cockpit/instance/Show/issues/shared/CloseProcessIssueModalForm';
import { useAuthorization } from 'framework/authorization';
import { ListItem, useListContext } from 'framework/list';

interface CloseIssueButtonProps {
  sourceIssueId: string;
}

const CLOSE_UNUSED_PROCESS_TASKS = 'CLOSE_UNUSED_PROCESS_TASKS';

const CloseIssueButton = ({ sourceIssueId }: CloseIssueButtonProps) => {
  const { data: { items = [] } = {}, updateInList = (entity: ListItem) => {} } = useListContext();

  const { getValue: getIssueId } = useFieldHelper<any>({ source: sourceIssueId });
  const { isGranted } = useAuthorization();

  const issueId = getIssueId();
  const issueData: any = items.filter((item: any) => item.id === issueId)[0];

  const updateIssueInList = useCallback(() => {
    updateInList({
      ...issueData,
      closedAt: new Date(),
    });
  }, [issueData, updateInList]);

  const isButtonHidden = issueData.hasActiveToken || issueData.closedAt || !isGranted(CLOSE_UNUSED_PROCESS_TASKS);

  const [isFormOpen, setIsFormOpen] = useState(false);
  const openCloseIssueForm = useCallback(() => {
    setIsFormOpen(true);
  }, [setIsFormOpen]);

  const closeModal = useCallback(() => {
    setIsFormOpen(false);
  }, [setIsFormOpen]);

  return !isButtonHidden ? (
    <>
      <Button className="instance-feedback-button" onClick={openCloseIssueForm}>
        <span>Close</span>
      </Button>
      {isFormOpen && (
        <CloseProcessIssueModalForm issueId={issueId} updateIssue={updateIssueInList} closeModal={closeModal} />
      )}
    </>
  ) : null;
};

export default CloseIssueButton;
